var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVaticanCity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:54072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 0.418945C24.836 0.418945 31.9995 7.58245 31.9995 16.4189C31.9995 25.2554 24.836 32.4189 15.9995 32.4189C15.9995 31.7233 13.9126 16.4189 13.9126 16.4189L15.9995 0.418945Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4189C7.1635 32.4189 0 25.2554 0 16.4189C0 7.58245 7.1635 0.418945 16 0.418945",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1273 14.3419L25.1343 18.3197C24.6605 19.0371 24.663 20.0036 25.211 20.7284C25.906 21.6479 27.2148 21.8299 28.1343 21.1348C29.0537 20.4398 29.2357 19.131 28.5406 18.2115C27.9928 17.4867 27.0635 17.2207 26.2441 17.4809L21.5578 11.2813L20.448 12.1203L18.783 13.3787L20.461 15.5984L22.1273 14.3419ZM26.4563 18.915C26.7628 18.6832 27.1991 18.744 27.4308 19.0504C27.6624 19.3569 27.6018 19.7932 27.2953 20.0249C26.9889 20.2565 26.5526 20.196 26.3209 19.8894C26.0891 19.5829 26.1498 19.1466 26.4563 18.915V18.915Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.284 15.5982L28.962 13.3785L27.2971 12.12L26.1873 11.281L21.501 17.4806C20.6817 17.2205 19.7524 17.4865 19.2045 18.2113C18.5094 19.1308 18.6914 20.4395 19.6108 21.1345C20.5303 21.8295 21.8391 21.6476 22.5341 20.7282C23.082 20.0033 23.0845 19.0368 22.6108 18.3195L25.6177 14.3416L27.284 15.5982ZM21.4242 19.8893C21.1926 20.1958 20.7563 20.2564 20.4498 20.0248C20.1433 19.793 20.0827 19.3567 20.3144 19.0502C20.546 18.7438 20.9823 18.6831 21.2889 18.9148C21.5953 19.1465 21.6559 19.5828 21.4242 19.8893V19.8893Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:54072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.418945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaticanCity);
export default __webpack_public_path__ + "static/media/vatican-city.ab2e1ad2.svg";
export { ForwardRef as ReactComponent };